import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

const NEWSLETTER_URL = "https://lp.constantcontactpages.com/sl/4lXnOxO/RemnantRevival";

export const NewsletterForm = () => (
  <a href={NEWSLETTER_URL} target="_blank" rel="noopener noreferrer" className="btn-gold inline-flex items-center gap-2" data-testid="newsletter-signup-link">
    <Mail size={16} /> Join the Newsletter
  </a>
);

const COLS = [
  ["Explore", [["Free Discipleship Videos", "/videos"], ["Courses", "/courses"], ["Go Deeper", "/resources"], ["Free Resources", "/blog"]]],
  ["Grow", [["Coaching", "/coaching"], ["Partnership", "/partnership"], ["Events", "https://www.toddcoconato.com/events"], ["About Todd", "/about"]]],
  ["Support", [["Contact", "/contact"], ["Member Login", "/login"], ["Dashboard", "/dashboard"], ["Privacy & Cookies", "/contact#privacy"]]],
];

export default function Footer() {
  const { settings } = useSite();
  return (
    <footer className="relative border-t border-white/10 bg-[#03050B] mt-24" data-testid="site-footer">
      <div className="container-x py-16 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-6 text-sm text-slate-400 max-w-sm leading-relaxed">"Do not be conformed to this world, but be transformed by the renewing of your mind." <span className="text-gold-light">Romans 12:2</span></p>
          <div className="mt-8"><p className="label">Newsletter</p><NewsletterForm compact /></div>
        </div>
        {COLS.map(([h, links]) => (
          <div key={h}>
            <p className="font-accent text-xs tracking-[0.3em] text-gold-light mb-5">{h.toUpperCase()}</p>
            <ul className="space-y-3">
              {links.map(([l, to]) => (
                <li key={l}>{to.startsWith("http")
                  ? <a href={to} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</a>
                  : <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</Link>}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="container-x py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} The Transformed Mind Life. Founded by Todd Coconato.</span>
          <span>{settings?.contact?.email}</span>
        </div>
      </div>
    </footer>
  );
}
